import { render, staticRenderFns } from "./OfficeListItem.vue?vue&type=template&id=f036d794&scoped=true&"
import script from "./OfficeListItem.vue?vue&type=script&lang=js&"
export * from "./OfficeListItem.vue?vue&type=script&lang=js&"
import style0 from "./OfficeListItem.vue?vue&type=style&index=0&id=f036d794&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f036d794",
  null
  
)

export default component.exports